import React, { Component, PropTypes } from 'react';
import config from '../../../config';

let $ = window.jQuery;
let Handlebars = window.Handlebars;
let Bloodhound = window.Bloodhound;

export default class TypeaheadInput extends Component {
    static propTypes = {
        val: PropTypes.any.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired,
        handleSelectedData: PropTypes.func.isRequired,
        emptySearchText: PropTypes.string.isRequired,
        suggestionListTemplate: PropTypes.any.isRequired,
        searchURL: PropTypes.string.isRequired,
        typeAheadName: PropTypes.string.isRequired,
        display: PropTypes.string.isRequired,
        onChange: PropTypes.func
    };

    // Example of suggestion list template
    // Use Handlebars for templating
    //
    // Handlebars.compile([
    //     '<div class="media">',
    //     '<div class="pull-left">',
    //     '<div class="media-object">',
    //     '<img src="'+config.staticFiles+'{{image}}" width="50" height="50"/>',
    //     '</div>',
    //     '</div>',
    //     '<div class="media-body">',
    //     '<h4 class="media-heading">{{name}}</h4>',
    //     '<p>{{id}}</p>',
    //     '</div>',
    //     '</div>'
    // ].join(''))

    state = {
        val : ''
    };

    initTypeahead = () => {
        let queryData = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: `${config.apiUrl}${this.props.searchURL}?q=%QUERY`,
                wildcard: '%QUERY',
                filter: (response) => {
                    return response.data;
                }
            }
        });

        let $el = $('#remote #' + this.props.id);

        $el.typeahead(null, {
            name: this.props.typeAheadName,
            display: this.props.display,
            source: queryData,
            templates: {
                empty: Handlebars.compile([
                    '<div class="empty-message" style="font-size: 13px; color: #000; padding: 10px;">',
                    this.props.emptySearchText,
                    '</div>'
                ].join('\n')),
                suggestion: this.props.suggestionListTemplate
            }
        }).on('typeahead:selected', (obj, datum) => {
            this.handleSelectedData(datum);
        }).on('typeahead:change', (obj, datum) => {
            this.handleSelectedData(datum);
        }).on('typeahead:active', (e) => {
            $(e.target).siblings('.form-control-focus').remove();
            $(e.target).siblings('.help-block').remove();
            $(e.target).parent().append('<div class="form-control-focus"></div><span class="help-block">'+this.props.help+'</span>');
        });
    };

    handleSelectedData = (data) => {
        this.props.handleSelectedData(data);
    };

    handleChange = (e) => {
        this.setState({
            val: e.target.value
        })
    };

    componentDidMount() {
        this.setState({
            val: this.props.val
        });

        // Initialize typeahead
        this.initTypeahead();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.val !== '') {
            this.setState({
                val: nextProps.val
            });
        } else {
            this.setState({
                val: ''
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        return (
            <div className="form-group form-md-line-input" id="remote">
                <input type="text" className="form-control typeahead"
                       value={this.state.val}
                       onChange={this.handleChange}
                       id={this.props.id} placeholder={this.props.label} />
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/TypeaheadInput.js
 **/